import { GapRepresentativeValue } from '@ebalance/proto/bffuser/v1/supply_demand_gap_model_pb'

export const REP_VALUE_OPTIONS: Array<{
  value: GapRepresentativeValue
  labelKey: string
}> = [
  {
    value: GapRepresentativeValue.BASE,
    labelKey: 'page:supplyGap.filter.repBase',
  },
  {
    value: GapRepresentativeValue.PEAK,
    labelKey: 'page:supplyGap.filter.repPeak',
  },
  {
    value: GapRepresentativeValue.OFFPEAK,
    labelKey: 'page:supplyGap.filter.repOffpeak',
  },
]
